import {createRouter, createWebHistory} from 'vue-router';
import api from '../services/api';

// Views
import Login from '../views/Login.vue';
import NotFound from '../views/NotFound.vue';
import RoleDashboard from '../views/RoleDashboard.vue';
import ForgotPasswordView from '../views/ForgotPasswordView.vue';
import ResetPasswordView from '../views/ResetPasswordView.vue';
import SchoolYears from '../views/SchoolYears.vue';
import Students from '../views/Students.vue';
import Groups from '../views/Groups.vue';
import Users from '../views/Users.vue';
import OffersDayView from '../views/OffersDayView.vue';
import AdminOffersList from '../views/AdminOffersList.vue';
import Notifications from '../views/Notifications.vue';
import NotificationMessages from '../views/NotificationMessages.vue';
import FollowDay from '../views/FollowDay.vue';
import TeacherInfos from '../views/TeacherInfos.vue';
import AdminChangeLogs from '../views/AdminChangeLogs.vue';
import ParentAbsences from '../views/ParentAbsences.vue';
import Analytics from '../views/Analytics.vue';
import Documentation from '../views/Documentation.vue';
import AbsenceDaysCard from '../views/analytics/AbsenceDaysCard.vue';
import Tickets from '../views/Tickets.vue';
import TicketDetail from '../views/TicketDetail.vue';
import Impressum from '../views/Impressum.vue';
import Datenschutz from '../views/Datenschutz.vue';
import Outbox from '../views/Outbox.vue';
import Maintenance from '@/views/Maintenance.vue';
import AutoOfferRules from '@/views/AutoOfferRules.vue';
import SchoolEnrollmentLanding from '../views/SchoolEnrollmentLanding.vue';
import AdminSchoolEnrollments from '../views/AdminSchoolEnrollments.vue';

const routes = [
    {
        path: '/maintenance',
        name: 'Maintenance',
        component: Maintenance
    },
    {
        path: '/',
        meta: {requiresAuth: true},
        children: [
            {
                path: 'dashboard',
                name: 'Dashboard',
                component: RoleDashboard,
                meta: {title: 'Dashboard'},
                alias: ['', 'admin/dashboard']
            },
            {
                path: 'school-years',
                name: 'SchoolYears',
                component: SchoolYears,
                meta: {title: 'Schuljahre', allowedRoles: ['admin', 'teacher']}
            },
            {
                path: 'students',
                name: 'Students',
                component: Students,
                meta: {title: 'Schüler', allowedRoles: ['admin', 'teacher']}
            },
            {
                path: 'groups',
                name: 'Groups',
                component: Groups,
                meta: {title: 'Gruppen', allowedRoles: ['admin', 'teacher']}
            },
            {
                path: 'users',
                name: 'Users',
                component: Users,
                meta: {title: 'Benutzer', allowedRoles: ['admin', 'teacher']}
            },
            {
                path: 'offers',
                name: 'TeacherOffersList',
                component: AdminOffersList,
                meta: {title: 'Angebote – Übersicht', allowedRoles: ['teacher']}
            },
            {
                path: 'admin/offers',
                name: 'AdminOffersList',
                component: AdminOffersList,
                meta: {title: 'Angebote – Übersicht', allowedRoles: ['admin','teacher']}
            },
            {
                path: 'admin/change-logs',
                name: 'AdminChangeLogs',
                component: AdminChangeLogs,
                meta: {title: 'Logbuch', allowedRoles: ['admin']}
            },
            {
                path: 'admin/school-enrollment',
                name: 'AdminSchoolEnrollments',
                component: AdminSchoolEnrollments,
                meta: {title: 'Schulanmeldungen', allowedRoles: ['admin']}
            },
            {
                path: 'offers-day-view',
                name: 'OffersDayView',
                component: OffersDayView,
                meta: {title: 'Angebote – Tagesübersicht', allowedRoles: ['admin', 'teacher']}
            },
            {
                path: 'auto-offers',
                name: 'AutoOfferRules',
                component: AutoOfferRules,
                meta: {title: 'Auto-Angebote – Zyklen', allowedRoles: ['admin', 'teacher']}
            },
            {
                path: 'notifications',
                name: 'Notifications',
                component: Notifications,
                meta: {title: 'Meldungen', allowedRoles: ['admin', 'teacher', 'parent']}
            },
            {
                path: 'notifications/messages',
                name: 'NotificationMessages',
                component: NotificationMessages,
                meta: {title: 'Nachrichten', allowedRoles: ['admin', 'teacher']}
            },
            {
                path: 'follow-day',
                name: 'FollowDay',
                component: FollowDay,
                meta: {title: 'Folgetag', allowedRoles: ['admin','teacher']}
            },
            {
                path: 'teacher-infos',
                name: 'TeacherInfos',
                component: TeacherInfos,
                meta: {title: 'Hinweise', allowedRoles: ['admin', 'teacher', 'parent']}
            },
            {
                path: 'tickets',
                name: 'Tickets',
                component: Tickets,
                meta: {
                    title: 'Tickets',
                    allowedRoles: ['admin', 'teacher'],
                    sidebarLabel: 'Tickets',
                    sidebarIcon: 'pi pi-ticket' // optional, falls Ihre Sidebar Icons unterstützt
                }
            },
            {
                path: 'tickets/:id',
                name: 'TicketDetail',
                component: TicketDetail,
                meta: {
                    title: 'Ticket',
                    allowedRoles: ['admin', 'teacher'],
                    hiddenInSidebar: true // Detailansicht nicht im Menü anzeigen
                }
            },
            {
                path: 'analytics',
                name: 'Analytics',
                component: Analytics,
                meta: {title: 'Auswertung', allowedRoles: ['admin', 'teacher']}
            },
            {
                path: 'analytics/absences',
                name: 'AnalyticsAbsenceDays',
                component: AbsenceDaysCard,
                meta: {
                    title: 'Fehlzeiten – Auswertung',
                    allowedRoles: ['admin', 'teacher'],
                    sidebarLabel: 'Fehlzeiten',
                    sidebarIcon: 'pi pi-calendar-times'
                }
            },
            {
                path: 'documentation',
                name: 'Documentation',
                component: Documentation,
                meta: {title: 'Dokumentation', allowedRoles: ['admin', 'teacher', 'parent']}
            },
            {
                path: 'outbox',
                name: 'Outbox',
                component: Outbox,
                meta: {title: 'Postausgang', allowedRoles: ['admin', 'teacher']}
            },
            {
                path: 'parent/absences',
                name: 'ParentAbsences',
                component: ParentAbsences,
                meta: {title: 'Fehlzeiten', allowedRoles: ['parent']}
            },
        ]
    },
    {
        path: '/',
        children: [
            {
                path: 'schulanmeldung',
                name: 'SchoolEnrollment',
                component: SchoolEnrollmentLanding,
                meta: {title: 'Schulanmeldung'}
            },
            {
                path: 'login',
                name: 'Login',
                component: Login,
                meta: {title: 'Anmelden'}
            },
            {
                path: 'forgot-password',
                name: 'ForgotPassword',
                component: ForgotPasswordView,
                meta: {title: 'Passwort vergessen'}
            },
            {
                path: 'reset-password',
                name: 'ResetPassword',
                component: ResetPasswordView,
                meta: {title: 'Passwort zurücksetzen'}
            },
            {
                path: 'impressum',
                name: 'Impressum',
                component: Impressum,
                meta: {title: 'Impressum'}
            },
            {
                path: 'datenschutz',
                name: 'Datenschutz',
                component: Datenschutz,
                meta: {title: 'Datenschutz'}
            }
        ]
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound,
        meta: {title: 'Seite nicht gefunden'}
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

// Navigation Guard
router.beforeEach(async (to, from, next) => {
    // Titel
    document.title = to.meta.title ? `${to.meta.title} | Anwesenheitslisten` : 'Anwesenheitslisten';

    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const isAuthenticated = !!token;

    // Wenn Wartungsflag gesetzt ist, immer auf Maintenance (außer wir sind schon dort)
    const isMaintenance = (() => {
        try {
            return localStorage.getItem('app_maintenance') === '1';
        } catch (e) {
            return false;
        }
    })();

    if (isMaintenance && to.name !== 'Maintenance') {
        return next({name: 'Maintenance'});
    }

    // Unauth zu Login
    if (requiresAuth && !isAuthenticated) {
        return next({name: 'Login'});
    }

    // Bereits eingeloggt → Login nicht zulassen
    if (to.name === 'Login' && isAuthenticated) {
        // Wenn Aufruf im /spa-Namespace, dort auf Dashboard verweisen
        if (to.path && to.path.startsWith('/spa')) {
            return next({name: 'Dashboard'});
        }
        return next({name: 'Dashboard'});
    }

    // Rollen-Gate
    const allowedRoles = to.matched
        .map(r => r.meta?.allowedRoles)
        .filter(Boolean)
        .flat();

    const roleId = user?.roleId;
    const roleName = roleId === 1 ? 'admin' : roleId === 2 ? 'teacher' : roleId === 3 ? 'parent' : undefined;

    if (allowedRoles.length > 0) {
        if (!roleName || !allowedRoles.includes(roleName)) {
            return next({name: 'Dashboard'});
        }
    }

    // Serverseitige Session-Validierung
    // Wichtig: NICHT für Maintenance-Route prüfen (und auch nicht, wenn Flag aktiv ist)
    if (requiresAuth && isAuthenticated && to.name !== 'Maintenance' && !isMaintenance) {
        try {
            await api.get('/auth/check');
            return next();
        } catch (e) {
            // Wartung: Token NICHT löschen, sondern Maintenance anzeigen
            if (e && (e.code === 'MAINTENANCE')) {
                return next({name: 'Maintenance'});
            }

            localStorage.removeItem('token');
            localStorage.removeItem('user');
            return next({name: 'Login'});
        }
    }

    return next();
});

export default router;
